import React from 'react';
import FactFinderSummary from '../components/FactFinder/FactFinderSummary';

const FactFinderSummaryPage = () => <FactFinderSummary />;
 
export default FactFinderSummaryPage; 